export default __webpack_public_path__ + "static/media/img5.959e55e9.png";